/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgLocateNodeRight = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        clipRule="evenodd"
        d="M12 4a5 5 0 1 0 0 10 5 5 0 0 0 0-10zM5 9a7 7 0 1 1 2.808 5.606l-4.1 4.101-1.415-1.414 4.1-4.1A6.97 6.97 0 0 1 5 9zm13.215 9.016-.788-.797 1.423-1.406 3.165 3.203-3.165 3.203-1.423-1.406.788-.797H13.61v-2z"
        fill="currentcolor"
        fillRule="evenodd"
      />
    </g>
  </Icon>
);
export { SvgLocateNodeRight as LocateNodeRight };
